import axios from 'axios';

let thankYouForm = document.querySelector('#thank-you-form');
if(thankYouForm) {
    thankYouForm.querySelector('button').addEventListener('click', function() {
        axios.post(thankYouForm.attributes['data-action'].value,
            {
                'email': thankYouForm.querySelector('[name="email"]').value,
                'action': thankYouForm.querySelector('[name="action"]').value,
                'phone': thankYouForm.querySelector('[name="phone"]').value,
            }, {
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
            .then(function (response) {
                thankYouForm.querySelector('.thank-you-form-data').style.display = 'none'
                thankYouForm.querySelector('.thank-you-form-error-message').style.display = 'none'
                thankYouForm.querySelector('.thank-you-form-message').style.display = 'block'
            })
            .catch(function (error) {
                thankYouForm.querySelector('.thank-you-form-error-message').style.display = 'block'
                thankYouForm.querySelector('.thank-you-form-error-message').textContent = error.response.data.error
                thankYouForm.querySelector('.thank-you-form-message').style.display = 'none'
            })
    })
}
